import { render, staticRenderFns } from "./copyReading.vue?vue&type=template&id=53c7a3fc&scoped=true&"
import script from "./copyReading.vue?vue&type=script&lang=js&"
export * from "./copyReading.vue?vue&type=script&lang=js&"
import style0 from "./copyReading.vue?vue&type=style&index=0&id=53c7a3fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c7a3fc",
  null
  
)

export default component.exports